<!--Footer Starts-->
<footer class="footer">
  <div class="container-fluid">
    <p class="copyright text-center font-italic">
      &copy; {{currentDate | date: 'yyyy'}} <a>Axico Healthcare</a>
    </p>
  </div>
</footer>
<!--Footer Ends-->
